import Mock from "mockjs";

import commondata from "./commonmockdata.json"

Mock.mock(/\/api\/commondata\/findInsuranceCompanies/, "post", commondata.insuranceCompanies);

Mock.mock(/\/api\/commondata\/findByCondition/, "post", function(options){
    console.log(options.body)
    return Mock.mock(commondata.salesmans)
});